import React from 'react'
import PropTypes from 'prop-types'
import WrappedDrawer from '@/components/WrappedDrawer'
import MemberEntitlementDetail from './MemberEntitlementDetail'

class MemberEntitlementDrawer extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    record: PropTypes.object
  }

  render () {
    const { children, record } = this.props
    const name = record && record.name ? String(record.name).trim() : ''
    return (
      <WrappedDrawer
        children={children}
        title={name ? `${name}的套餐` : '套餐详情'}
        width={480}
        footer={null}
        maskClosable={true}
        destroyOnClose={true}
        baseComponent={<MemberEntitlementDetail />}
        baseProps={{ record }}
      />
    )
  }
}

export default MemberEntitlementDrawer
